export const isDev: boolean = import.meta.env.NODE_ENV === 'development';
export const isTest: boolean = import.meta.env.VITE_APP_ENV === 'test';
export const baseURL: string = import.meta.env.VITE_APP_BASE_API as string;

export const prevStoreKey = 'prevStoreKey';
export const prevStoreTid = 'prevStoreTid';

export const selectedStoreKey = 'selectedStoreKey';

export const accessTokenName = 'xa-token';

export const tenantTokenName = 'tenant-Id';

export const iconScriptUrl = '/icont-font/v3.js';
